import { render, staticRenderFns } from "./InvoiceAvatars.vue?vue&type=template&id=3be080d0&"
import script from "./InvoiceAvatars.vue?vue&type=script&lang=js&"
export * from "./InvoiceAvatars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports